import { InputWapper } from "@/utils/helper";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Input, Radio, Select, Modal, Button } from "antd";
import classNames from "classnames";
import { get, uniqWith, isEqual } from "lodash";
import React, { useEffect, useMemo, useState, useContext } from "react";
import { isMobile } from "../../../utils/common";
import "./index.less";
import { contexData } from "@/store";

import { language } from "@/utils/language";


// 普通单选
export default function BaseRadio(props) {
  console.log(`src\\pages\\radio\\BaseRadio\\index.jsx`, props);
  const {
    info = {},
    changeAnswer,
    selectedCodes,
    setSelectedCodes,
    unsetValue,
    answer,
    position,
    themeId,
    isMinimalTheme,
  } = props;
  const { infoContex } = useContext(contexData);
  const minimalTheme =
    Number(themeId || info?.themeId) === 4 || !!isMinimalTheme;
  let OPTIONCOLUMNS = get(info, "preferences.optionPrefer.optionsColumns", 1);
  if (!OPTIONCOLUMNS) OPTIONCOLUMNS = 1;
  // 0：普通，1：下拉
  const optionForm = get(info, "childPrefer.optionForm", 0);
  const limit = get(info, "childPrefer.limit", 0);

  const [options] = useState(() => {
    const options = info.options || [];
    let isModuleCollection = false;
    const newOptions = [];
    let index = 0;
    for (let i = 0; i < options.length; i++) {
      if (+options[i].moduleOption === 3) {
        isModuleCollection = true;
        index = i;
        newOptions.push(options[i]);
      } else if (+options[i].moduleOption !== 0) {
        isModuleCollection = false;
      }
      if (isModuleCollection) {
        if (index !== i) {
          const oldChildrenOption =
            newOptions[newOptions.length - 1].childrenOption || [];
          newOptions[newOptions.length - 1].childrenOption = [
            ...oldChildrenOption,
            options[i],
          ];
        }
      } else {
        newOptions.push(options[i]);
      }
    }
    return newOptions;
  });
  const [collapseStatus, setCollapseStatus] = useState(() => {
    return (info.options || [])
      .filter((item) => +item.moduleOption === 3)
      .reduce((acc, current) => {
        return {
          ...acc,
          [current.id]: false,
        };
      }, {});
  });
  const [selected, setSelected] = useState(() => {
    const selectedOption = (info.options || []).find(
      (item) => +item.selected === 1
    );
    if (selectedOption) {
      return selectedOption.id;
    }
    return "";
  });

  // init radio check
  useEffect(() => {
    const answerObj = answer[info.id];
    let key;
    if (answerObj) {
      key = Object.keys(answerObj)?.[0];
    }
    setSelected(key);
  }, [answer]);




  useEffect(() => {
    if (selected) {
      changeAnswer({
        [selected]: null,
      });
    }
  }, []);

  const width = useMemo(() => {
    let OPTNUMS = get(info, "preferences.optionPrefer.optionsColumns", 1);
    if (!OPTNUMS) OPTNUMS = 1;
    let width = 100;
    if (isMobile) {
      if (OPTNUMS > 3) {
        OPTNUMS = 3;
      }
      width = 99 / OPTNUMS;
    }
    width = 99 / OPTNUMS;
    return width + "%";
  }, [info]);

  // 点击选项
  const onOptionClick = (option) => () => {
    if (!!option.fixed) return;
    if (!!option.disable) return;
    if (limit) {
      const { codeValue } = option;
      unsetValue(codeValue);
    }
    setSelected(option.id);
    changeAnswer({
      [option.id]: null,
    });
  };

  // moduleOption: 0 正常选项， 1 只显示， 2 隐藏， 3 点击展开
  // 网格下拉，手机端
  const getSelectOptions = (options) => {
    const selectOptions = options.map((option) => {
      if (+option.moduleOption === 0 && !option.hide) {
        return (
          <Select.Option key={option.id} value={option.id}>
            <div dangerouslySetInnerHTML={{ __html: option.description }} />
          </Select.Option>
        );
      }
      return null;
    });
    const optionId = Object.keys(answer[info.id] || {})?.[0];
    const option = options.find((o) => o.id === optionId) || {};
    const defaultValue = answer[info.id]?.[optionId]?.text;
    return (
      <>
        <Select
          style={{ width: "100%" }}
          value={option.id}
          onChange={(optionId) => {
            const option = info.options.find((o) => o.id === optionId);
            const code = option.codeValue;
            const obj = Object.assign({}, selectedCodes, { [position]: code });
            setSelectedCodes(obj);
            changeAnswer({ [optionId]: null });
          }}
        >
          {selectOptions.filter((n) => n)}
        </Select>
        {!!option.open && (
          <InputWapper unit={option.unit}>
            <Input
              placeholder={language().input_placeholder}
              defaultValue={defaultValue}
              onChange={(e) =>
                changeAnswer({
                  [option.id]: e.target.value,
                })
              }
            />
          </InputWapper>
        )}
      </>
    );
  };

  // 网格下拉，一个选项只能选一遍
  // 这个只是上面的函数的加强版，还有优化的空间
  const getSelectOptionsSigle = (options) => {
    const selectOptions = options.map((option) => {
      if (+option.moduleOption === 0 && !option.hide) {
        // 之前选中的置灰
        const selected = [];
        for (const [key, value] of Object.entries(selectedCodes)) {
          if (+key < position) {
            selected.push(value);
          }
        }
        const isSelected = selected.includes(option.codeValue);
        const isMultiSelect = option.optionType === "1";

        return (
          <Select.Option
            key={option.id}
            value={option.id}
            disabled={(isSelected && !isMultiSelect) || option.disable}
          >
            <div
              style={{}}
              dangerouslySetInnerHTML={{ __html: option.description }}
            />
          </Select.Option>
        );
      }
      return null;
    });
    // 如果上面的题的码值和当前的重复，当前题要清空
    let optionId = Object.keys(answer[info.id] || {})?.[0];
    const option = options.find((o) => o.id === optionId) || {};
    const inputValue =
      answer[info.id]?.[optionId]?.text || answer[info.id]?.[optionId];

    for (const index in selectedCodes) {
      if (Object.hasOwnProperty.call(selectedCodes, index)) {
        if (position > +index) {
          const code = selectedCodes[index];
          if (option.codeValue === code) {
            optionId = undefined;
          }
        }
      }
    }

    return (
      <>

        <Select
          style={{ width: "100%" }}
          value={optionId}
          onChange={(optionId) => {
            const option = info.options.find((o) => o.id === optionId);
            const code = option.codeValue;
            for (const index in selectedCodes) {
              if (Object.hasOwnProperty.call(selectedCodes, index)) {
                const code = selectedCodes[index];
                if (option.codeValue === code) {
                  delete selectedCodes[index];
                }
              }
            }
            const obj = Object.assign({}, selectedCodes, { [position]: code });
            setSelectedCodes(obj);
            changeAnswer({ [optionId]: null });
          }}
        >
          {selectOptions.filter((n) => n)}
        </Select>
        {!!option.open && (
          <InputWapper unit={option.unit}>
            <Input
              placeholder={language().input_placeholder}
              defaultValue={inputValue}
              onChange={(e) =>
                changeAnswer({
                  [option.id]: e.target.value,
                })
              }
            />
          </InputWapper>
        )}
      </>
    );
  };

  // 生成选项
  const getOptions = (options) => {

    if (optionForm === 1) return getSelectOptions(options);
    if (optionForm === 2) return getSelectOptionsSigle(options);
    if (options && options.length > 0) {
      return (
        <>
          {options.map((option) => {
            if (+option.moduleOption === 2 || option.hide) return null;
            if (+option.moduleOption === 1) {
              return (
                <div
                  key={option.id}
                  className="q-content-module"
                  style={{ color: infoContex?.preferences?.optionColour }}
                  dangerouslySetInnerHTML={{
                    __html: option.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />
              );
            }
            if (+option.moduleOption === 3) {
              return (
                <React.Fragment key={option.id}>
                  <div
                    className="q-content-module-collapse"
                    onClick={() => {
                      setCollapseStatus((state) => ({
                        ...state,
                        [option.id]: !collapseStatus[option.id],
                      }));
                    }}
                  >
                    {collapseStatus[option.id] ? (
                      <MinusCircleOutlined />
                    ) : (
                      <PlusCircleOutlined />
                    )}
                    <div
                      style={{ color: infoContex?.preferences?.optionColour }}
                      dangerouslySetInnerHTML={{
                        __html: option.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>
                  {/* /// 多列不能设置 */}
                  {collapseStatus[option.id] &&
                    uniqWith(option.childrenOption, isEqual).filter(item => item.hide !== 1).map((childOption) => {
                      // ---------------------------------------------------------
                      // 记录上一页答案
                      const answerObj = answer[info.id] || {};
                      const keys = Object.keys(answerObj);
                      let value;
                      keys.map((optId) => {
                        if (optId === childOption.id) {
                          value = answerObj[optId]?.text || answerObj[optId];
                        }
                      });
                      // ---------------------------------------------------------

                      return (
                        <div key={childOption.id} style={{ width }}>
                          <div
                            className={classNames(
                              "q-content-option",
                              " q-content-childoption"
                            )}
                            onClick={onOptionClick(childOption)}
                          >
                            <Radio
                              checked={selected === childOption.id}
                              disabled={
                                +childOption.fixed === 1 || childOption.disable
                              }
                            />
                            <div
                              style={{
                                color: infoContex?.preferences?.optionColour,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: childOption.description,
                              }}
                            />
                          </div>
                          {+childOption.open > 0 &&
                            selected === childOption.id && (
                              <div style={{ marginBottom: 10 }}>
                                <InputWapper unit={childOption.unit}>
                                  <Input
                                    placeholder={language().input_placeholder}
                                    value={value}
                                    onChange={(e) =>
                                      changeAnswer({
                                        [childOption.id]: e.target.value,
                                      })
                                    }
                                  />
                                </InputWapper>
                              </div>
                            )}
                        </div>
                      );
                    })}
                </React.Fragment>
              );
            }

            // ---------------------------------------------------------
            // 记录上一页答案
            const answerObj = answer[info.id] || {};
            const keys = Object.keys(answerObj);
            let value;
            keys.map((optId) => {
              if (optId === option.id) {
                value = answerObj[optId]?.text || answerObj[optId];
              }
            });
            // ---------------------------------------------------------

            return (
              <div key={option.id} style={{ width, paddingBottom: minimalTheme?0:10 ,minHeight: minimalTheme?30:42}}>
                <div
                  className="q-content-option"
                  onClick={onOptionClick(option)}
                  style={{
                    flexWrap:
                      +option.open > 0 && selected === option.id
                        ? "wrap"
                        : "nowrap",
                  }}

                >
                  <Radio
                    checked={selected === option.id}
                    disabled={+option.fixed === 1 || option.disable}
                  />

                   <div
                    style={{ color: infoContex?.preferences?.optionColour ,
                      width:+option.open>0 ?"":'100%',
                      paddingRight:'20px'
                    }}
                    dangerouslySetInnerHTML={{
                      __html:(option.description
                        .replace(/<p><\/p>/g, "<br />")
                        .replace(/\n\n/g, "<br />")
                        .replace(/\s{2}/g, "&nbsp;&nbsp;")),
                    }}
                  />

                  {+option.open > 0 && selected === option.id && (
                    <div style={{ marginLeft: 10 }}>
                      <InputWapper unit={option.unit}>
                        <Input
                          placeholder={language().input_placeholder}
                          value={value}
                          onChange={(e) =>
                            changeAnswer({
                              [option.id]: e.target.value,
                            })
                          }
                        />
                      </InputWapper>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </>
      );
    }

    return null;
  };

  return (
    <div className={classNames("base-radio", { "theme-minimal": minimalTheme })}>

      <div className={classNames("q-content", { "theme-minimal": minimalTheme })}>
        <div className="q-content-options">{getOptions(options)}</div>
      </div>
    </div>
  );
}
